import { Select } from "antd";
import React from "react";
import { CONNECTED_INFO } from "../../../constants/constant";

const ConnectedBy = (props) => {
    return (
        <>
            <Select {...props} getPopupContainer={(triggerNode) => triggerNode.parentElement} allowClear>
                {CONNECTED_INFO?.map((data) => {
                    return (
                        <Select.Option key={data?.id} value={data.id}>
                            {data?.name}
                        </Select.Option>
                    );
                })}
            </Select>
        </>
    );
};
export default ConnectedBy;
